__turbopack_context__.v({
  "back_button": "MobileMenuLegacy-module-scss-module__qsDijW__back_button",
  "gear_icon": "MobileMenuLegacy-module-scss-module__qsDijW__gear_icon",
  "genre_links": "MobileMenuLegacy-module-scss-module__qsDijW__genre_links",
  "genres_button": "MobileMenuLegacy-module-scss-module__qsDijW__genres_button",
  "genres_open": "MobileMenuLegacy-module-scss-module__qsDijW__genres_open",
  "genres_toggle": "MobileMenuLegacy-module-scss-module__qsDijW__genres_toggle",
  "is_open": "MobileMenuLegacy-module-scss-module__qsDijW__is_open",
  "links": "MobileMenuLegacy-module-scss-module__qsDijW__links",
  "live_tv_icon": "MobileMenuLegacy-module-scss-module__qsDijW__live_tv_icon",
  "mobile_menu": "MobileMenuLegacy-module-scss-module__qsDijW__mobile_menu",
  "mobile_menu_genre_nav_link": "MobileMenuLegacy-module-scss-module__qsDijW__mobile_menu_genre_nav_link",
  "mobile_menu_inner": "MobileMenuLegacy-module-scss-module__qsDijW__mobile_menu_inner",
  "mobile_menu_profile": "MobileMenuLegacy-module-scss-module__qsDijW__mobile_menu_profile",
  "mobile_menu_wrapper": "MobileMenuLegacy-module-scss-module__qsDijW__mobile_menu_wrapper",
  "my_station_icon": "MobileMenuLegacy-module-scss-module__qsDijW__my_station_icon",
  "name_sign_out": "MobileMenuLegacy-module-scss-module__qsDijW__name_sign_out",
  "passport_compass": "MobileMenuLegacy-module-scss-module__qsDijW__passport_compass",
  "personal": "MobileMenuLegacy-module-scss-module__qsDijW__personal",
  "profile_name": "MobileMenuLegacy-module-scss-module__qsDijW__profile_name",
  "sign_out": "MobileMenuLegacy-module-scss-module__qsDijW__sign_out",
});
